import { AnswerMode } from './AnswerMode';

/**
 * Class representing a true-false answer mode.
 * @extends AnswerMode
 */
export class TrueFalseAnswerMode extends AnswerMode {}
